import api from './api';

export interface RastreabilidadeTimelineEvento {
  data: string | null;
  titulo: string;
  descricao: string;
  icon: string;
  color: string;
  link?: string;
}

export interface RastreabilidadeOrigemItem {
  lote_numero: string;
  produto_nome: string;
  fornecedor: string;
  quantidade: number;
  validade: string | null;
}

export interface RastreabilidadeDestinoItem {
  cliente: string;
  nf: string;
  data_venda: string;
  quantidade: number;
}

export interface RastreabilidadeOpItem {
  numero: string;
  produto_nome: string;
  status: string;
  data_inicio: string | null;
  quantidade: number;
}

export interface RastreabilidadeResultado {
  tipo: string;
  tipo_label: string;
  identificador: string;
  produto_nome: string;
  quantidade: number;
  data: string | null;
  validade?: string | null;
  status: string;
  timeline: RastreabilidadeTimelineEvento[];
  origem: RastreabilidadeOrigemItem[];
  destino: RastreabilidadeDestinoItem[];
  ops: RastreabilidadeOpItem[];
}

export interface RastreabilidadeReferencia {
  id: string;
  tipo: string;
  tipo_label: string;
  identificador: string;
  produto_nome: string;
  produto_codigo?: string | null;
  quantidade: number;
  data: string | null;
  status: string;
  origem?: string | null;
}

export interface RastreabilidadeDashboard {
  total: number;
  lotes_pa: number;
  lotes_mp: number;
  ops: number;
  em_producao: number;
  livres: number;
  quarentena: number;
}

export interface RastreabilidadeReferenciasResponse {
  dashboard: RastreabilidadeDashboard;
  items: RastreabilidadeReferencia[];
}

const ENDPOINT = '/industrializacao/rastreabilidade';

const rastreabilidadeService = {
  async listarReferencias(filters: { tipo?: string; search?: string } = {}): Promise<RastreabilidadeReferenciasResponse> {
    const response = await api.get<RastreabilidadeReferenciasResponse>(`${ENDPOINT}/referencias`, { params: filters });
    return response.data;
  },
  async rastrear(tipo: string, termo: string): Promise<RastreabilidadeResultado> {
    const response = await api.get<RastreabilidadeResultado>(ENDPOINT, { params: { tipo, termo } });
    return response.data;
  },
  async rastrearPorLote(numeroLote: string): Promise<RastreabilidadeResultado> {
    const response = await api.get<RastreabilidadeResultado>(`${ENDPOINT}/lote`, { params: { numero_lote: numeroLote } });
    return response.data;
  },
};

export default rastreabilidadeService;
